import React from "react";

export const Bin = (props) => {
  const newProps = { ...props };
  delete newProps.tag;

  return (
    <props.tag {...newProps}>
      <svg className="w-full fill-current" viewBox="0 0 32 32">
        <path d="M13 15h2v6h-2zM17 15h2v6h-2z" />
        <path d="M20 9c0-.6-.4-1-1-1h-6c-.6 0-1 .4-1 1v2H8v2h1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V13h1v-2h-4V9zm-6 1h4v1h-4v-1zm7 3v9H11v-9h10z" />
      </svg>
    </props.tag>
  );
};
Bin.defaultProps = {
  tag: "div",
  title: "Delete icon",
  className:
    "w-8 text-rose-400 hover:text-rose-600 rounded-full cursor-pointer",
};

export const Edit = (props) => {
  const newProps = { ...props };
  delete newProps.tag;

  return (
    <props.tag {...newProps}>
      <svg className="w-full fill-current" viewBox="0 0 32 32">
        <path d="M19.7 8.3c-.4-.4-1-.4-1.4 0l-10 10c-.2.2-.3.4-.3.7v4c0 .6.4 1 1 1h4c.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4l-4-4zM12.6 22H10v-2.6l6-6 2.6 2.6-6 6zm7.4-7.4L17.4 12l1.6-1.6 2.6 2.6-1.6 1.6z" />
      </svg>
    </props.tag>
  );
};
Edit.defaultProps = {
  tag: "div",
  title: "Edit icon",
  className:
    "w-8 text-slate-400 hover:text-slate-500 rounded-full cursor-pointer",
};

export const View = (props) => {
  const newProps = { ...props };
  delete newProps.tag;

  return (
    <props.tag {...newProps}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        className="w-full stroke-current stroke-2"
      >
        <path
          stroke="none"
          d="M0 0h24v24H0z"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="12" r="2" />
        <path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7" />
      </svg>
    </props.tag>
  );
};
View.defaultProps = {
  tag: "div",
  title: "View icon",
  className:
    "w-5 text-emerald-500 hover:text-emerald-300 rounded-full cursor-pointer",
};

export const Submit = (props) => {
  const newProps = { ...props };
  delete newProps.tag;

  return (
    <props.tag {...newProps}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="check-circle"
        class="w-5 h-5 mr-2 fill-current"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          fill="currentColor"
          d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
        ></path>
      </svg>
    </props.tag>
  );
};
Submit.defaultProps = {
  tag: "div",
  title: "View icon",
  className:
    "w-5 text-emerald-500 hover:text-emerald-300 rounded-full cursor-pointer",
};

export const Reload = (props) => {
  const newProps = { ...props };
  delete newProps.tag;

  return (
    <props.tag {...newProps}>
      <div className="flex justify-center items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-5 h-5 text-[#9297a2]"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
          />
        </svg>
      </div>
    </props.tag>
  );
};
Reload.defaultProps = {
  tag: "div",
  title: "Reload icon",
  className:
    "w-8 text-emerald-500 hover:text-emerald-300 rounded-full cursor-pointer",
};

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"></svg>;

export const Assignment = (props) => {
  const newProps = { ...props };
  delete newProps.tag;

  return (
    <props.tag {...newProps}>
      <div className="flex justify-center items-center">
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="w-5 h-5 text-gray-700"
        > */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          className="w-5 h-7 text-gray-700"
        >
          <path d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
        </svg>
      </div>
    </props.tag>
  );
};
Assignment.defaultProps = {
  tag: "div",
  title: "Assignment icon",
  className:
    "w-8 text-emerald-500 hover:text-emerald-300 rounded-full cursor-pointer",
};